import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { PaginationInstance } from 'ngx-pagination';
import { Modal } from '../../../../node_modules/ngx-modal';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { UserRole } from '../../customerservice/constants/user-role.constants';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { DataShareService } from '../../shared/services/data.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { Constants, DefaultTicketType } from '../common/constants';
import { SearchRequestConstants } from '../common/search-request-constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { Status } from '../enums/ticket-status.enum';
import { TicketType } from '../enums/ticket-type.enum';
import { AssignTickets, PaginationReq } from '../interface/ticketingsystem/bulk-assign-tickets-req';
import { SearchModel } from '../interface/ticketingsystem/search.model';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { WorkTicket } from '../interface/ticketingsystem/work-ticket';
import { DeleteModal } from '../models/delete-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from './../services/department.service';
import { NotificationType } from '../enums/notification-types.enum';
@Component({
    selector: 'my-team-tickets',
    templateUrl: '../templates/template1/views/my-team-tickets.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/ticket.less', '../templates/template1/themes/default/css/my-team-tickets.component.less'
    ]
})
export class MyTeamTicketsComponent implements OnInit {
    ticketEditForm: FormGroup;
    rightContentWidth = 1000;
    active = true;
    id: any;
    tabTitle: string;
    componentName: any;
    tabModel: ViewTabModel;
    tabs: any[] = new Array<ViewTabModel>();
    existedValues: ViewTabModel[] = new Array<ViewTabModel>();
    deleteModal: DeleteModal;
    justifyingTabs = false;
    ticketTypes: any[];
    departments: any[];
    disputeReason: any[];
    userInfo: UserInfo;
    myTickets: any[] = new Array<WorkTicket>();
    allTickets: any[] = new Array<WorkTicket>();
    showAllTickets = true;
    ticketSearchModel: any;
    isSearch: boolean;
    ticketTypeOnSelectAll = true;
    departmentOnSelectAll = true;
    assignToOnSelectAll = true;
    sourceOnSelectAll = true;
    statusOnSelectAll = true;
    subTypeOnSelectAll = true;
    priorityOnSelectAll = true;
    disputeReasonOnSelectAll=true;
    isClearClicked = false;
    createdByOnSelectAll = true;
    assignedToId: any;
    userDepartments: any[];
    users: any[];

    pageNumber = 1;
    pageSize = 25;
    pageCount = 0;
    isDesc = true;
    pageSizes: number[] = [10, 25, 50, 75];

    sortColumn: any = 'TICKET_NUMBER';
    sort = 'DESC';
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';

    isTicketView: any;
    @Input() isDiputeTicketSearch: boolean;
    disputeSearch = false;
    ticketAssignForm: FormGroup;
    assignBulkTicketPanel: boolean;
    selectedTickets: any[] = new Array<WorkTicket>();
    bulkAssignReq: PaginationReq;
    isBulkAssignSearch: boolean;
    bulkTicketAssignees: any[];
    isSubmitted: boolean;
    isFormInvalid: boolean;
    bulkAssignDepts: any[];
    bulkAssignStatus: any[];
    selectAll = false;
    unAssinged: boolean;
    overDueDisable: boolean;
    ticketsOnSelectAll: any[] = new Array<WorkTicket>();
    ticketSpamOrUnspamForm: FormGroup;
    isAllSelectedTicketsSpamedOrUnspamed: boolean;
    message = '';
    closed = 0;
    countryId: number;
    fieldTypes: SearchRequestConstants;
    @ViewChild('spamOrUnspamTicketConfirmationModal') spamOrUnspamTicketConfirmation: Modal;
    @ViewChild('emailname') email:NgModel;
    /**
     * Pagination instance - to avoid console warnings - inorder to assign id for pagination
     */
    public paginationInstance: PaginationInstance = {
        id: 'my-team-tickets-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };
    @Input() operatingCountries: any;
    @Input() statusTypes: any;
    @Input() sourceTypes: any;
    @Input() ticketPriorities: any;

   public dropdownSettings: any = {
        sourceDropdownList: [],
        sourceSelectedItems: [],
        sourceIndex: 1,
        typeDropdownList: [],
        typeSelectedItems: [],
        typeIndex: 2,
        subTypeDropdownList: [],
        subTypeSelectedItems: [],
        subTypeIndex: 3,
        statusDropdownList: [],
        statusSelectedItems: [],
        statusIndex: 4,
        priorityDropdownList: [],
        prioritySelectedItems: [],
        priorityIndex: 5,
        departmentDropdownList: [],
        departmentSelectedItems: [],
        departmentIndex: 6,
        assignedToDropdownList: [],
        assignedToSelectedItems: [],
        assignedToIndex: 7,
        createdByDropdownList: [],
        createdBySelectedItems: [],
        createdByIndex: 8,
        disputeReasonDropdownList: [],
        disputeReasonSelectedItem : [],
        disputeReasonIndex:9,
        settings: {},
    };
    constructor(private _cacheService: CacheService, private _dataShareService: DataShareService
         , private _commonService: CommonService,
         private departmentService: DepartmentService,
         private _customerservice: CustomerService,
         private _formbuilder: FormBuilder,
         private _translatePipe: TranslateService,
         private messageService: MessageService, private  chRef:  ChangeDetectorRef) {

    }
    ngOnInit(): void {
         this.buildForm();
         this.buildSpamForm();
         this.intializeMultiselectDropdowns();
         this.dropdownSettings.settings = {
            singleSelection: false,
            text: 'select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            enableSearchFilter: false,
            classes: 'myclass custom-class',
            badgeShowLimit: 1

        };
        this.tabModel = new ViewTabModel();
        this.fieldTypes = new SearchRequestConstants();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_TICKETS_VIEW + ']'), AccessLevel.Customer_Service);
        this.assignedToId = this.userInfo.userId;
        this.active = false;
        this.activetab = 1;
        this.overDueDisable = false;
        this.ticketSearchModel = new SearchModel;
        this.countryId = this.getAllowedCountries();
        this.getOperatingCountries();
        this.ticketSearchModel.overDueCount = false;
        this.showAllTickets = true;
         this.getTicketTypesAndSubTypes();
        if (this.userInfo.privileges.departments && !this.userInfo.hasSystemRole) {
            this.userDepartments = this.userInfo.privileges.departments.map(function (a) { return a.id; });
        }
        this.getDepartments();
        this.getTicketStatus();
        this.showAllTickets = false;
        this.getSourceTypes();
        this.getTicketPriorities();
        this._dataShareService.customerServiceMessage.subscribe(message => {
            if (message && message !== '') {
                const splittedMessage = message.split('-');
                this.rightContentWidth = parseInt(splittedMessage[0])   ;
              }
        });
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),

            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.isDiputeTicketSearch ? this.disputeSearch = true : '';
        this.closed = Status.Closed;
    }

    activetab: number;
    selectTab(tab: any) {
        this.activetab = tab;
    }
    changeTab(tab: any) {
        this.activetab = tab;
    }
    doNotRemoveFormData() {
        //data should not be removed...
    }
    subscribeTabContent() {
        this.messageService.getCustomerServiceTabContent().subscribe((data: any) => {
            if (data) {
                this.id = data.id;
                this.tabTitle = data.tabName;
                this.componentName = data.componentName;
                this.addNewTab();
                this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
            }
        });
    }

    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
  */
    subscribeClosedTabs() {
        this.messageService.getCloseTabsEvent().subscribe((data: any) => {
            if (data) {
                this.closeAllOpenedTabs();
            }
        });
    }
    addNewTab(): void {
        const newTabIndex = this.tabs.length + 1;
        this.tabModel = new ViewTabModel();

        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.componentName = this.componentName;
        this.existedValues = new Array<ViewTabModel>();
        const index = this.tabs.map(function (el) {
            return el.id;
        }).indexOf(this.id);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            this.displayAlertBoxOnReachingMaxTabs();
        } else {
            if (index < 0) {
                this.tabs.push(this.tabModel);
            } else {
                const selectedId = this.id;
                this.tabs.forEach(function (x: ViewTabModel) {
                    if (x.id !== selectedId) {
                        x.active = false;
                    } else {
                        x.active = true;
                    }
                });
            }
        }
    }
    /**
     * removes tab at specific index
     * @param tab
     */
    removeTabHandler(tab: any): void {
        if (this.tabs) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        }
    }

    /**
     * Close all opened tabs
     */
    closeAllOpenedTabs() {
        this.tabs = []; //new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
    }

    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    displayAlertBoxOnReachingMaxTabs() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    }
    openDropDown(element: string) {
        const elem = document.getElementById(element);
        const dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute('hidden');
    }
    onDropDowneBlur(element: string) {
        const elem = document.getElementById(element);
        const dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute('hidden', 'true');
    }
    getEditPermission(departmentId: number) {
        if (departmentId) {
            const isView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_DEPARTMENT_TICKETS_EDIT + ']'), AccessLevel.Department, departmentId);
            return isView;
        } else {
            return false;
        }
    }
    /**
    * display alert box if the logged in user do not have permission to see the fbo/retail information
    */
    displayAlertbox() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    }
    /**
     * @description To Search Tickets
     * @date 2020-01-31
     * @param {boolean} [tabChange]
     * @memberof MyTeamTicketsComponent
     */
    onSearch(tabChange?: boolean): void {
        const searchBtn = document.getElementById('search-button');
        if (searchBtn) {
            searchBtn.classList.add('button-active');
            setTimeout(() => {
                searchBtn.classList.remove('button-active');
            }, 1000);
        }
        if (!tabChange) {
            this.pageNumber = 1;
        } else {
            this.pageNumber = isNaN(this.pageNumber) ? 1 : this.pageNumber;
        }
        this.getTicketsSearch(true);
    }
      /**
       * search with ticket number
       */
      searchWithTicketNumber() {
        if (this.ticketSearchModel.ticketNumber  || this.ticketSearchModel.email) {
            this.dropdownSettings.settings = {...this.dropdownSettings.settings, disabled: true};
            this.chRef.detectChanges();
            this.overDueDisable = true;
            this.OnTabSearchFocus();

            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
        } else {
            this.dropdownSettings.settings = {...this.dropdownSettings.settings, disabled: false};
            this.chRef.detectChanges();
            this.overDueDisable = false;
          }
    }
      getDepartments() {
        this._customerservice.getAllDepartmentsByOperatingCountryId(this.countryId).subscribe((response) => {
            if (response) {
                this.departments = response;
                this.departments.sort(function (item1, item2) {
                    const dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase();
                    if (dept1 < dept2) { //sort string ascending
                        return -1;
                    }
                    if (dept1 > dept2) {
                        return 1;
                    }
                    return 0;
                });
                if (!this.userInfo.hasSystemRole) {
                    if (this.userInfo.privileges.departments && this.userInfo.privileges.departments.length > 0) {
                        const departmentIds = this.userInfo.privileges.departments.map(function (a: any) { return a.id; });
                    }
                }
                this.departments.forEach(item => {
                    this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value });
                });
                this.dropdownSettings.departmentSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.departmentDropdownList));
                 this.bulkAssignDepts =  this.dropdownSettings.departmentSelectedItems;
                 if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                    this.getAssignedUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id), true);
                }
                this.setFocusToTextBox();
            }
        });
      }

      getAssignedUsersByDepartments(departmentIds: number[], onLoad?: Boolean) {
        if (departmentIds) {
            this.dropdownSettings.assignedToDropdownList = [];
            this.dropdownSettings.assignedToSelectedItems = [];
            this.dropdownSettings.createdByDropdownList=[];
            this.dropdownSettings.createdBySelectedItems=[];
            this._customerservice.getAssignedUsersByDepartmentIds(departmentIds).subscribe(response => {
            if (response) {
                this.users = response;
                
                 this.users.forEach(item => {
                    this.dropdownSettings.assignedToDropdownList.push({ id: item.id, itemName: item.name.trim() });                    
                    this.dropdownSettings.createdByDropdownList.push({ id: item.id, itemName: item.name.trim() });
                });

                if(this.dropdownSettings != null) 
                {
                    if(this.dropdownSettings.assignedToDropdownList !=null && !this.dropdownSettings.assignedToDropdownList.find(user => user.id === 1)) 
                    {
                        this.dropdownSettings.assignedToDropdownList.push({ id: 1, itemName: UserRole.SuperAdministrator }); 
                    }
                    if(this.dropdownSettings.createdByDropdownList !=null && !this.dropdownSettings.createdByDropdownList.find(user => user.id === 1)) 
                    {
                        this.dropdownSettings.createdByDropdownList.push({ id: 1, itemName: UserRole.SuperAdministrator }); 
                    }
                }
                 this.dropdownSettings.assignedToDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });

                this.dropdownSettings.createdByDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                if (onLoad) {
                 this.dropdownSettings.assignedToSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.assignedToDropdownList));
                 this.dropdownSettings.createdBySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.createdByDropdownList));
                }
                if (this.isClearClicked) {
                    this.onSearch();
                    this.isClearClicked = false;
                }
            } else {
                 this.users = [];
                 this.dropdownSettings.assignedToDropdownList = [];
                 this.dropdownSettings.assignedToSelectedItems = [];
                 this.dropdownSettings.createdByDropdownList=[];
                 this.dropdownSettings.createdBySelectedItems=[];
            }
        });
        }
    }
    resetBulkAssigForm() {
        this.ticketAssignForm.reset();
        this.ticketAssignForm.controls['statusId'].setValue('');
        this.ticketAssignForm.controls['departmentId'].setValue('');
        this.ticketAssignForm.controls['assignToId'].setValue('') , Validators.required;
        this.isFormInvalid = false;
        this.isSubmitted = false;
        this.bulkTicketAssignees = [];
        this.selectedTickets = [];
    }

    resetTicketSpamOrUnspamForm() {
        this.ticketSpamOrUnspamForm.reset();
        this.isFormInvalid = false;
        this.selectedTickets = [];
        this.ticketSpamOrUnspamForm.controls['ticketId'].setValue(''), Validators.required;
    }

     /*
    form data to download to pdf/ csv/print
    */
   Download(type: string) {
    const columns = [
        this._translatePipe.get('ticketing-system.Priority')['value'],
        this._translatePipe.get('ticketing-system.Ticket#')['value'],
        this._translatePipe.get('ticketing-system.Assigned to User')['value'],
        this._translatePipe.get('ticketing-system.Subject')['value'],
        this._translatePipe.get('ticketing-system.Ticket Subtype')['value'],
        this._translatePipe.get('ticketing-system.Dispute Reason')['value'],
        this._translatePipe.get('ticketing-system.Status')['value'],
        this._translatePipe.get('ticketing-system.Due Date')['value'],
        this._translatePipe.get('ticketing-system.Created Date')['value'],
        this._translatePipe.get('ticketing-system.Created By')['value'],
        this._translatePipe.get('ticketing-system.Last Modified Date')['value']];

    let rowdata = new Array<any>();
    const finalrows = new Array<any>();
    this._customerservice.SearchTicketsOnPagination(null,
        (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0  && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.assignedToSelectedItems.map((item: any) => item.id) : []),
        this.ticketSearchModel.ticketNumber,
        (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.statusSelectedItems.map((item: any) => item.id)),
        (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
        this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.unAssinged : null,
        this.ticketSearchModel.email ? this.ticketSearchModel.email :null,
        this.ticketSearchModel.email ? this.countryId:null, 
        (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map((item: any) => item.id) : []),true
    ).subscribe((response)=>{
        if (response && response['content']) {
            const tickets=response['content'];
            for (let i = 0; i < tickets.length; i++) {
                rowdata = [];
                const a1 = tickets[i];

            rowdata.push(a1.priorityValue);
            rowdata.push('\t' + a1.ticketNumber);
            rowdata.push(a1.assignedToValue ? a1.assignedToValue : '');
            rowdata.push(a1.subject);
            rowdata.push(a1.subType);
            rowdata.push(a1.disputeReasonName ? a1.disputeReasonName : '');
            rowdata.push(a1.status);
            rowdata.push(a1.dueDate ? moment.utc(a1.dueDate).utcOffset(0).format('DD-MMM-YYYY') : '');
            rowdata.push(a1.createdDate ? moment.utc(a1.createdDate).utcOffset(0).format('DD-MMM-YYYY') : '');
            rowdata.push(a1.createdByName ? a1.createdByName: '');
            rowdata.push(a1.modifiedDate ? moment.utc(a1.modifiedDate).utcOffset(0).format('DD-MMM-YYYY') : '');
            
            finalrows.push(rowdata);
        }
    }const title =  this._translatePipe.get('ticketing-system.My Team Tickets')['value'];
    this._customerservice.ExcelDownload(columns, finalrows, 'My Team Tickets', title);

       })
    
    }
    getTicketsSearch(isClearSelectedItems?: boolean) {
        if(this.email.control.status.toLocaleUpperCase() == Constants.VALID.toLocaleUpperCase() && !(this.ticketSearchModel.ticketNumber && this.ticketSearchModel.email)){
        if (isClearSelectedItems) {
            this.selectAll = false;
            this.selectedTickets = [];
        }
        if (this.isBulkAssignSearch) {
            this.resetBulkAssigForm();
            this.isBulkAssignSearch = false;

        }
        if (this.isAllSelectedTicketsSpamedOrUnspamed) {
            this.resetTicketSpamOrUnspamForm();
            this.isAllSelectedTicketsSpamedOrUnspamed = false;

        }
        if (!(this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length > 0)) {
           this.dropdownSettings.statusSelectedItems.push({ id: Status.InProgress, itemName: Status[Status.InProgress] });
           this.statusOnSelectAll = false;
        }
        this._customerservice.SearchTicketsOnPagination(null,
                (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0  && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.assignedToSelectedItems.map((item: any) => item.id) : []),
                this.ticketSearchModel.ticketNumber,
                (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.statusSelectedItems.map((item: any) => item.id)),
                (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
                this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.unAssinged : null,
                this.ticketSearchModel.email ? this.ticketSearchModel.email :null,
                this.ticketSearchModel.email ? this.countryId:null, 
                (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map((item: any) => item.id) : []),false
                ).subscribe((response: WorkTicket[]) => {
                    if (response) {
                        this.pageCount = response['totalCount'];
                        this.allTickets = response['content'];
                        this.myTickets = response['content'];
                        if (this.allTickets && this.allTickets.length) {
                            this.allTickets.forEach(x => {
                                if (x.dueDate) {
                                    x.dueDate = moment.utc(x.dueDate)
                                        .utcOffset(0).format('DD-MMM-YYYY');
                                }
                                if (x.createdDate) {
                                    x.createdDate = moment.utc(x.createdDate)
                                        .utcOffset(0).format('DD-MMM-YYYY');
                                }
                                if (x.modifiedDate) {
                                    x.modifiedDate = moment.utc(x.modifiedDate)
                                        .utcOffset(0).format('DD-MMM-YYYY');
                                }
                                if (this.selectedTickets.find(ticket => ticket.id === x.id )) {
                                    x.isSelected = true;
                                }
                            });
                            this.selectAll = this.myTickets.every(ticket => ticket.isSelected === true);
                        }
                    } else {
                        this.pageCount = 0;
                        this.myTickets = [];
                        this.allTickets = [];
                    }
            this.getAssignToUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id));
            this.setFocusToTextBox();
        });
    }
    }
    getTicketTypes() {
        this._customerservice.getTicketTypes().subscribe((response) => {
            if (response) {
                this.ticketTypes = response;
                this.ticketTypes.sort(function (item1, item2) {
                    const tickettype1 = item1.value.toLowerCase(), tickettype2 = item2.value.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
            }
        });
    }
    subTypesSort() {
            this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                if (tickettype1 < tickettype2) { //sort string ascending
                    return -1;
                }
                if (tickettype1 > tickettype2) {
                    return 1;
                }
                return 0;
            });
    }
    ticketTypesSort() {
            this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                if (tickettype1 < tickettype2) { //sort string ascending
                    return -1;
                }
                if (tickettype1 > tickettype2) {
                    return 1;
                }
                return 0;
            });
    }
    getTicketTypesAndSubTypes() {
        this.departmentService.getTicketTypesAndSubTypes(this.countryId).subscribe(response => {
            if (response && !this.isDiputeTicketSearch) {
                this.ticketTypes = response;
                this.ticketTypes.forEach(item => {
                     let operatingCountryName: string;
                    if (item.operatingCountryName !== null) {
                        operatingCountryName = item.operatingCountryName.trim();
                    } else if (item.operatingCountryName === null && (item.value == DefaultTicketType.Orders || item.value == DefaultTicketType.Products)) {
                        operatingCountryName = 'ALL';
                    }
                     const ticketType = operatingCountryName + ' ' + '-' + ' ' + item.value.trim();
                    this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: ticketType });

                    if (item.value.trim().includes('FLP360')) {
                        item.subTypes.forEach((subType: any) => {
                            const subTypeName =  subType.name.trim() + '(' + item.value.trim() + ')';
                          
                                this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            
                        });
                    } else {
                        item.subTypes.forEach((subType: any) => {
                          
                                this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                            
                        });
                    }

                     this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.subTypeDropdownList));
                     if (item.value.trim() === TicketType.Order) {
                        this.getDisputeReasons();
                     } 
                    });
                this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                 this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
            } else if (response && this.isDiputeTicketSearch) {
                this.ticketTypes = response.filter((type: any) => type.value === TicketType.Order);
                this.ticketTypes.forEach(item => {
                    this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: item.value.trim() });
                    this.dropdownSettings.typeSelectedItems.push({ id: item.id, itemName: item.value.trim() });
                });
                const selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id);
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {

                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach((subType: any) => {
                            const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subTypeName });
                        });
                    } else {
                        type.subTypes.forEach((subType: any) => {
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                            this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subType.name.trim() });
                        });
                    }
                  

                });
                this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
            }
        });
    }

    getSourceTypes() {
        if (this.sourceTypes) {
            this.sourceTypes.forEach(item => {
                this.dropdownSettings.sourceDropdownList.push({ id: item.id, itemName: item.value });
            });
             this.dropdownSettings.sourceSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.sourceDropdownList));
        }
    }

    getTicketPriorities() {
        if (this.ticketPriorities) {

            this.ticketPriorities.forEach(item => {
                this.dropdownSettings.priorityDropdownList.push({ id: item.id, itemName: item.value });
            });
             this.dropdownSettings.prioritySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.priorityDropdownList));
        }
    }

    getTicketStatus() {
        if (this.statusTypes) {
            this.dropdownSettings.statusSelectedItems = [];
            this.statusTypes.forEach(item => {
                this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
                if (item.id === Status.InProgress || item.id === Status.New
                    || item.id === Status.OnHold) {
                    this.dropdownSettings.statusSelectedItems.push({ id: item.id, itemName: item.value });
                    this.statusOnSelectAll = false;
                }
         });
         this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
        }
    }

    /**
     * sort table by respective column
     * @param sortColumn
     */
    sortTableByColumn(sortColumn: string) {
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? 'DESC' : 'ASC';
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.myTickets.length === 0) {
            return;
        }
        if (this.isBulkAssignSearch === true) {
            this.getBulkAssignTickets();
            return;
        }
        this.getTicketsSearch();
    }
    /**
       * On Page change
       * @param pageNumber
       */
    pageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            if (this.isBulkAssignSearch) {
                this.bulkAssignReq.pageNumber = pageNumber;
                this.getBulkAssignTickets();
            } else {
                this.pageNumber = pageNumber;
                this.getTicketsSearch();
            }
        }
    }

     onItemSelect(item: any, indexValue: any) {

         if (this.dropdownSettings.departmentIndex === +indexValue) {
            if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                this.bulkAssignDepts =  this.dropdownSettings.departmentSelectedItems;
                this.departmentOnSelectAll = false;
                      if (this.departments.length === this.dropdownSettings.departmentSelectedItems.length) {
                       this.departmentOnSelectAll = true;
                   }
            } else {
                this.departments.forEach(item => {
                    this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value.trim() });
                });
            }
            if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                const deptIds = this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id);
                this.getAssignedUsersByDepartments(deptIds);
                this.ticketAssignForm.controls['departmentId'].patchValue(deptIds);
            } else {
                this.dropdownSettings.assignedToDropdownList = [];
                this.dropdownSettings.assignedToSelectedItems = [];
                this.dropdownSettings.createdByDropdownList = [];
                this.dropdownSettings.createdBySelectedItems = [];
                this.ticketAssignForm.controls['departmentId'].setValue('');
            }
        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
              if (this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length) {
                     this.statusOnSelectAll = true;
               }
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
             if (this.sourceTypes.length === this.dropdownSettings.sourceSelectedItems.length) {
                     this.sourceOnSelectAll = true;
               }
        } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
             if (this.dropdownSettings.subTypeDropdownList.length === this.dropdownSettings.subTypeSelectedItems.length) {
                     this.subTypeOnSelectAll = true;
                    }
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
                 this.departmentOnSelectAll = false;
                if (this.departments.length === this.dropdownSettings.departmentSelectedItems.length) {
                     this.departmentOnSelectAll = true;
                   }
          } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            this.unAssinged = false;
            if (this.users.length === this.dropdownSettings.assignedToSelectedItems.length) {
                     this.assignToOnSelectAll = true;
                     this.unAssinged = true;
                   }
        } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
             if (this.ticketPriorities.length === this.dropdownSettings.prioritySelectedItems.length) {
                    this.priorityOnSelectAll = true;
                   }
        }else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
            this.unAssinged = false;
            if (this.users.length === this.dropdownSettings.createdBySelectedItems.length) {
                     this.createdByOnSelectAll = true;
                     this.unAssinged = true;
                   }
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
           if (this.disputeReason.length === this.dropdownSettings.disputeReasonSelectedItem.length) {
                this.disputeReasonOnSelectAll = true;
              }
        }
         if (this.dropdownSettings.typeIndex === +indexValue) {
             if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                 const selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id);
                 this.dropdownSettings.subTypeDropdownList = [];
                  this.dropdownSettings.subTypeSelectedItems = [];
                 this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach((subType: any) => {
                            const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                                this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                                this.ticketTypeOnSelectAll = false;
                         });
                    } else {
                        type.subTypes.forEach((subType: any) => {
                                this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                                this.ticketTypeOnSelectAll = false;
                            });
                    }
                    if (type.value === TicketType.Order) {
                        this.getDisputeReasons();
                        this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
                    } else {
                        this.dropdownSettings.disputeReasonDropdownList=[];
                        this.dropdownSettings.disputeReasonSelectedItem=[];
                    }

                 });
                  if (this.ticketTypes.length === this.dropdownSettings.typeSelectedItems.length) {
                          this.ticketTypeOnSelectAll = true;
                         } else {
                        this.ticketTypeOnSelectAll = false;
                   }
             }
        }
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
            this.bulkAssignStatus = this.bulkAssignStatus.filter(item => item.id !== Status.Closed);
        }
    }
     onItemDeSelect(item: any, indexValue: any) {
        if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypesSort();
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {

                const selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id);
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {
                this.subTypesSort();
                if (type.value.trim().includes('FLP360')) {
                    type.subTypes.forEach((subType: any) => {
                        const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        this.ticketTypeOnSelectAll = false;
                        this.ticketTypesSort();
                    });
                } else {
                    type.subTypes.forEach((subType: any) => {
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                        this.ticketTypeOnSelectAll = false;
                        this.ticketTypesSort();
                    });
                }
                if (type.value === TicketType.Order) {
                    this.getDisputeReasons();
                    this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
                    this.disputeReasonOnSelectAll = false;
                } else {
                    this.dropdownSettings.disputeReasonDropdownList=[];
                    this.dropdownSettings.disputeReasonSelectedItem=[];
                    this.ticketTypeOnSelectAll = false;
                }
                });

            } else if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length === 0 && this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter((item: any) => item.itemName.includes(TicketType.Order));
            } else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList=[];
                this.dropdownSettings.disputeReasonSelectedItem=[];
            }
        }

        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.showAllTickets) {
                this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
            } else if (this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length === 0) {
                 this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));            //    this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
             }
        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;

        } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            this.unAssinged = false;
            if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
                this.unAssinged = true;
              }
        } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
        }else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
            this.unAssinged = false;
            if (this.dropdownSettings.createdBySelectedItems.length === 0) {
                this.unAssinged = true;
              }
        } else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
        }
    }
    onSelectAll(items: any, indexValue: any) {
       if (this.dropdownSettings.typeIndex === +indexValue) {
                 this.dropdownSettings.subTypeDropdownList = [];
                  this.dropdownSettings.subTypeSelectedItems = [];
                 this.ticketTypes.forEach(type => {
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach((subType: any) => {
                            const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                         });
                    } else {
                            type.subTypes.forEach((subType: any) => {
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                        });
                    }

                    if (type.value === TicketType.Order) {
                        this.getDisputeReasons();
                        this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
                        this.disputeReasonOnSelectAll = true;
                    } else {
                        this.dropdownSettings.disputeReasonDropdownList=[];
                        this.dropdownSettings.disputeReasonSelectedItem=[];
                    }
                 });
                 this.ticketTypeOnSelectAll = true;
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = true;

        } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = true;
            this.unAssinged = true;

        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = true;
        } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = true;
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = true;
        } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = true;
        }else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = true;
            this.unAssinged = true;
        } 
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = true;
        }
        if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.bulkAssignDepts =  JSON.parse(JSON.stringify(this.dropdownSettings.departmentSelectedItems));
            this.getAssignedUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id));
        }
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
            this.bulkAssignStatus = this.bulkAssignStatus.filter(item => item.id !== Status.Closed);
        }
    }

    onDeSelectAll(items: any, indexValue: any) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter((item: any) => item.itemName.includes(TicketType.Order));
            } else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList=[];
                this.dropdownSettings.disputeReasonSelectedItem=[];
            }
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypeOnSelectAll = false;
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
            this.bulkTicketAssignees = [];
        } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
                this.unAssinged = true;
              }

        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
            if (this.dropdownSettings.createdBySelectedItems.length === 0) {
                this.unAssinged = true;
              }
        } else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
        }
    }

     showAllTicketsCheckBox( event: any) {
        this.dropdownSettings.statusSelectedItems = [];
       if (event.target.checked) {
          this.showAllTickets = true;
          this.dropdownSettings.statusSelectedItems =  JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
       } else {
          this.showAllTickets = false;
          this.dropdownSettings.statusSelectedItems =  this.dropdownSettings.statusDropdownList.filter((item: any) => item.id === Status.InProgress);
       }
       this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
       this.bulkAssignStatus = this.bulkAssignStatus.filter(item => item.id !== Status.Closed);

    }

    ShowTicketAndDepatrmentBycountry(countryId) {
        this.countryId = countryId;
        this.dropdownSettings.typeDropdownList = [];
		this.dropdownSettings.subTypeDropdownList = [];
		this.dropdownSettings.subTypeSelectedItems = [];
		this.dropdownSettings.typeSelectedItems = [];
        this.departments = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.users = [];
        this.dropdownSettings.assignedToDropdownList = [];
        this.dropdownSettings.assignedToSelectedItems = [];
        this.dropdownSettings.createdByDropdownList = [];
        this.dropdownSettings.createdBySelectedItems = [];
        this.disputeReason = [];
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this.getTicketTypesAndSubTypes();
        this.getDepartments();
        // this.getDisputeReasons();
    }

    /*
    Build form for bulk assign
    */
    buildForm() {
        this.unAssinged = true;
        this.ticketAssignForm = this._formbuilder.group(
            {
                departmentId: ['', Validators.required],
                assignToId: ['', Validators.required],
                statusId: ['']
            });
    }

    /*
    Build form for bulk spam
    */
    buildSpamForm() {
        this.ticketSpamOrUnspamForm = this._formbuilder.group(
            {
                ticketId: ['', Validators.required]
            }
        );
    }
    /*
    Submit form for bulk assign
    */

    submitForm(ticketAssingForm: any) {

        this.isSubmitted = true;
        const numOfTickets = this.selectedTickets.length;
        if (this.ticketAssignForm.valid) {
            this.isSubmitted = false;
            if (!this.selectedTickets || this.selectedTickets.length === 0) {
                this.isFormInvalid = true;
                return;
            } else {
                const assignee = this.bulkTicketAssignees.find(assigne => assigne.id === +ticketAssingForm.assignToId);
                const bulkTickets: any[] = new Array<AssignTickets>();
                let assignedToEmailId = '';
                if (this.bulkTicketAssignees && this.bulkTicketAssignees.length > 0) {
                    const assignedToUser =  this.bulkTicketAssignees.find(item => item.id === +ticketAssingForm.assignToId);
                    if (assignedToUser) {
                        assignedToEmailId = assignedToUser.email;
                    }
                }
                this.selectedTickets.forEach(ticket => bulkTickets.push({
                    id: ticket.id,
                    ticketNumber: ticket.ticketNumber,
                    modifiedBy: this.userInfo.userId,
                    agentEmail: this.userInfo.email,
                    agentName: this.userInfo.firstName + ' ' + this.userInfo.lastName,
                    assignedToEmail: assignedToEmailId,
                    userId: ticketAssingForm.assignToId
                }));
                this._customerservice.assignBulkTickets(bulkTickets).subscribe(response => {
                    if (response) {
                        this._commonService.createNotification('', numOfTickets + 'Ticket(s) assigned to ' + assignee.name + ' successfully', NotificationType.SUCCESS);
                        this.isBulkAssignSearch = true;
                        if (this.selectAll) {
                            this.pageNumber = this.pageNumber - 1;
                        }
                        this.selectAll = false;
                        this.getTicketsSearch();
                    } else {
                        this._commonService.createNotification('', 'Ticket(s) assignment failed', NotificationType.ERROR);
                    }
                });
            }
        } else {
            this.isSubmitted = true;
            if (!this.selectedTickets || this.selectedTickets.length === 0) {
                this.isFormInvalid = true;
                return;
            }
        }
    }

    getOperatingCountries() {
       if (this.operatingCountries) {
            const countryInfo = this.operatingCountries.find((country: any) =>  country.id === this.countryId);
            if (countryInfo) {
                this.operatingCountries.splice( this.operatingCountries.indexOf(countryInfo), 1 );
                this.operatingCountries.splice(0, 0, countryInfo);
            }
        }
    }

    getAllowedCountries() {
        let countryIds: any = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',').map(i => +i);
                if(countryIds.includes(OperatingCountryEnums.USA)){
                    return OperatingCountryEnums.USA;
                }
                return countryIds[0];
            }
        }
        return OperatingCountryEnums.USA;
    }

    getBulkAssignTickets() {
        if (this.bulkAssignReq.statusId && this.bulkAssignReq.statusId.length === 1 && this.bulkAssignReq.statusId[0].toString() === '') {
            let statusList = this.bulkAssignStatus;
            statusList = statusList.map((item: any) => item.id);
            this.bulkAssignReq.statusId = statusList;
        }
        if (this.bulkAssignReq.departmentId && this.bulkAssignReq.departmentId.length === 1 && this.bulkAssignReq.departmentId[0].toString() === '') {
            let deptsList = this.dropdownSettings.departmentSelectedItems;
            deptsList = deptsList.map((item: any) => item.id);
            this.bulkAssignReq.departmentId = deptsList;
        }
        this._customerservice.SearchTicketsOnPagination(null,
            (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 ? this.dropdownSettings.assignedToSelectedItems.map((item: any) => item.id) : []),
            this.ticketSearchModel.ticketNumber,
            (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 ? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
            (this.bulkAssignReq.departmentId),
            (this.bulkAssignReq.statusId),
            (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
            this.bulkAssignReq.pageNumber, this.bulkAssignReq.pageSize, this.sortColumn, this.sort, null, this.disputeSearch,
            (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map((item: any) => item.id) : []),
            ).subscribe((response: WorkTicket[]) => {
                if (response) {
                    this.pageCount = response['totalCount'];
                    this.myTickets = response['content'];
                    if (this.myTickets && this.myTickets.length) {
                        this.myTickets.forEach(x => {
                            if (x.dueDate) {
                                x.dueDate = moment.utc(x.dueDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.createdDate) {
                                x.createdDate = moment.utc(x.createdDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.modifiedDate) {
                                x.modifiedDate = moment.utc(x.modifiedDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                        });
                    }
                } else {
                    this.pageCount = 0;
                    this.myTickets = [];
                }
               if (this.selectedTickets) {
                    this.myTickets.forEach((ticket: any) => {
                        if (this.selectedTickets.find(item => item.id === ticket.id)) {
                            ticket.isSelected = true;
                        }
                    });
               }
            });
    }

    /*
    Submit form for bulk assign
    */
    onDeptChange() {
        this.ticketAssignForm.controls['assignToId'].setValue('');
        this.onChange();
    }
    onChange() {
        this.selectAll = false;
        const deptId = this.ticketAssignForm.controls['departmentId'].value;
        const statusId = this.ticketAssignForm.controls['statusId'].value;
        if (this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length === 1 && this.dropdownSettings.statusSelectedItems[0].id === Status.Closed
            && deptId) {
            this.myTickets = [];
            this.pageCount = 0;
            return;
        }
        this.isBulkAssignSearch = true;
        this.myTickets.forEach(ticket => ticket.isSelected = false);
        this.selectedTickets = [];
        this.bulkTicketAssignees = [];

        if (!deptId && !statusId) {
            this.getTicketsSearch();
            return;
        }
        this.bulkAssignReq = new PaginationReq;
        this.bulkAssignReq.pageNumber = 1;
        this.bulkAssignReq.sortColumn = 'TICKET_NUMBER';
        this.bulkAssignReq.departmentId = [];
        this.bulkAssignReq.departmentId.push(deptId);
        this.bulkAssignReq.statusId = [];
        this.bulkAssignReq.statusId.push(statusId);
        this.getBulkAssignTickets();
        this.getAllTicketOnFilter();
        if (deptId) {
            this._customerservice.getAssignedUsersByDepartments(+deptId).subscribe(response => {
                if (response) {
                    this.bulkTicketAssignees = response;
                }
            });
        }
    }
     /*
    on change of check box in tickets grid
    */
    onTicketSelect(event: any, myTickets?: WorkTicket[]) {
        this.isFormInvalid = false;
        if (event.target.checked) {
            if (myTickets.length) {
                for (const ticket of myTickets) {
                    if (!ticket.isSelected) {
                    ticket.isSelected = true;
                    this.ticketAssignForm.controls['departmentId'].setValue(ticket.id);
                    this.ticketSpamOrUnspamForm.controls['ticketId'].setValue(ticket.id);
                    this.selectedTickets.push({id: ticket.id, ticketNumber: ticket.ticketNumber});
                    }
                }
                this.selectAll = this.myTickets.every(ticket => ticket.isSelected === true);
            }
        } else {
            if (myTickets.length) {
                for (const ticket of myTickets) {
                ticket.isSelected = false;
                this.selectedTickets.splice(this.selectedTickets.map(ticket => ticket.id).indexOf(ticket.id), 1);
                }
                this.selectAll = this.myTickets.every(ticket => ticket.isSelected === true);
            }
        }
    }
    /*
    on change of check box for select all
    */
    onSelectAllChange() {
        if (this.selectAll) {
            this.selectedTickets = [];
            this.ticketsOnSelectAll.forEach(ticket => {
                this.selectedTickets.push({id: ticket.id, ticketNumber: ticket.ticketNumber});
            });
            this.myTickets.forEach(ticket => {
                ticket.isSelected = true;
            });
        } else {
            this.selectedTickets = [];
            this.myTickets.forEach(ticket => {
                ticket.isSelected = false;
            });
        }
    }

    getAllTicketOnFilter() { 
        this._customerservice.getAllTickets(null,
            (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 ? this.dropdownSettings.assignedToSelectedItems.map((item: any) => item.id) : []),
            this.ticketSearchModel.ticketNumber,
            (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 ? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
            (this.bulkAssignReq.departmentId),
            (this.bulkAssignReq.statusId),
            (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
            this.bulkAssignReq.pageNumber, this.bulkAssignReq.pageSize, this.sortColumn, this.sort,
            (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map((item: any) => item.id) : [])).subscribe((response: WorkTicket[]) => {
                if (response) {
                    this.ticketsOnSelectAll = response['content'];
                } else {
                    this.ticketsOnSelectAll = [];
                }
            });
    }
    getAssignToUsersByDepartments(departmentIds: number[]) {
        if (departmentIds && departmentIds.length > 0) {
                this._customerservice.getBulkAssignedUsersByDepartmentIds(departmentIds).subscribe(response => {
                    if (response) {
                        this.bulkTicketAssignees = response;
                    }
                });
        } else {
            this.bulkTicketAssignees = [];
        }

    }

    selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm: any) {
        if (this.ticketSpamOrUnspamForm.valid && ticketSpamOrUnspamForm) {
            if (!this.selectedTickets || this.selectedTickets.length === 0) {
                this.isFormInvalid = true;
                return;
            } else {
                this.openSpamOrUnspamTicketConfirmationPopup();
            }
        } else {
            this.isFormInvalid = true;
        }
    }

    closeSpamOrUnpsamTicketConfirmationPopup() {
        this.spamOrUnspamTicketConfirmation.close();
    }

    openSpamOrUnspamTicketConfirmationPopup() {
        this.spamOrUnspamTicketConfirmation.open();
    }

    unselectTicketsWhenSpamOrUnspamFailed() {
        this.selectedTickets.forEach(selectedTicket => {
            this.myTickets.forEach(myTicket => {
                if (selectedTicket.id === myTicket.id) {
                    myTicket.isSelected = false;
                }
            });
        });
    }
/* To spam or unspam the selected tickets */
    spamorUnspamSelectedTickets() {
        const listOfTicketsToBeSpamed = [];
        let spamOrUnspamReason: any;
        let isSpam: boolean;

        if (this.dropdownSettings.statusSelectedItems.length === 1 && this.dropdownSettings.statusSelectedItems[0].id === Status.Closed) {
            isSpam = false;
            spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as unspam');
        } else {
            isSpam = true;
            spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as spam');
        }

        this.selectedTickets.forEach(ticket => {
            listOfTicketsToBeSpamed.push({id: ticket.id, ticketNumber: ticket.ticketNumber, updatedBy: this.userInfo.userId, closeOtherReason: spamOrUnspamReason.value});
        });

        this._customerservice.markATicketorAllTicketsAsSpamOrUnpsam(listOfTicketsToBeSpamed, isSpam).subscribe(response => {
            if (response) {
                let success: any;
                if (isSpam) {
                    success = this._translatePipe.get('success-message.Ticket(s) marked as spam and closed successfully');
                } else {
                    success = this._translatePipe.get('success-message.Ticket(s) marked as not spam successfully');
                }
                this._commonService.createNotification('', success.value , NotificationType.SUCCESS);
                this.isAllSelectedTicketsSpamedOrUnspamed = true;
                if (this.selectAll) {
                    this.pageNumber = this.pageNumber - 1;
                }
                this.selectAll = false;
                this.getTicketsSearch();
            } else {
                let failed: any;
                if (isSpam) {
                    failed = this._translatePipe.get('error-message.Tickets couldn\'t be marked as spam');
                } else {
                    failed = this._translatePipe.get('error-message.Tickets couldn\'t be marked as unspam');
                }
                this._commonService.createNotification('', failed.value, NotificationType.ERROR);
                this.unselectTicketsWhenSpamOrUnspamFailed();
                this.isAllSelectedTicketsSpamedOrUnspamed = true;
                this.resetTicketSpamOrUnspamForm();
            }
        }, error => {
            const unknown: any = this._translatePipe.get('validation-message.Unknown Error');
            this.message = (error != null && error[0] != null) ? error[0].field + ' : ' + error[0].message : unknown.value;
            this._commonService.createNotification('', this.message, NotificationType.ERROR);
            this.unselectTicketsWhenSpamOrUnspamFailed();
            this.isAllSelectedTicketsSpamedOrUnspamed = true;
            this.resetTicketSpamOrUnspamForm();
        });
        this.spamOrUnspamTicketConfirmation.close();
    }

    setFocusToTextBox() {
        setTimeout(function() {
            const element = <HTMLInputElement>document.getElementById('ticketNumber');
            const email = <HTMLInputElement>document.getElementById('email');
            if (element.value) { element.focus(); }
            else if (email.value) { email.focus(); }
            else { element.focus(); }

         }, 1000);
    }

    OnTabEventRecentlyViewed() {
        const element = document.getElementById('ticketNumber');
        if (element) {
            element.focus();
        }
        event.preventDefault();
    }
    OnTabSearchFocus() {
        const element = document.getElementById('searchbutton');
        if (element) {
            element.focus();
        }
        event.preventDefault();
    }
    intializeMultiselectDropdowns() {

        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.statusDropdownList = [];
        this.dropdownSettings.statusSelectedItems = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.priorityDropdownList = [];
        this.dropdownSettings.prioritySelectedItems = [];
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this.dropdownSettings.settings = {
            text: 'Select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            classes: 'myclass custom-class',
            badgeShowLimit: 1,
        };
    }

    clearFields() {
        this.dropdownSettings.settings = {...this.dropdownSettings.settings, disabled: false};
        this.chRef.detectChanges();
        this.overDueDisable = false;
        this.setFocusToTextBox();
        this.getTicketTypesAndSubTypes();
        this.intializeMultiselectDropdowns();
        this.getSourceTypes();
        this.getTicketStatus();
        this.getDisputeReasons();
        this.showAllTickets = true;
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
        this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.getDepartments();
        this.getTicketPriorities();
        this.ticketSearchModel.ticketNumber = '';
        this.ticketSearchModel.email=''

        this.ticketTypeOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.selectedTickets = [];
        this.createdByOnSelectAll = true;
        this.disputeReasonOnSelectAll =true;
    }

    goToViewTicket(id: any, ticketNumber: any) {
        if (this.isTicketView) {
            const ticketTab = new TicketTabInfo();
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = 'View Ticket - ' + ticketNumber;
            ticketTab.viewTicket = true;
            ticketTab.isTeamTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        } else {
            this.displayAlertbox();
        }
    }
    getDisputeReasons() {
        this.dropdownSettings.disputeReasonDropdownList =[];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this._customerservice.getDisputeReasons().subscribe(response => {
            if (response) {
                this.disputeReason= response;
                this.disputeReason.forEach(item => {
                    this.dropdownSettings.disputeReasonDropdownList.push({ id: item.id, itemName: item.value.trim() });                    
                });
                this.dropdownSettings.disputeReasonDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
               // this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
            }else{
                this.disputeReason = [];
                this.dropdownSettings.disputeReasonDropdownList=[];
                this.dropdownSettings.disputeReasonSelectedItem=[];
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/my-team-tickets.component.ts